/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstTransportType } from './MstTransportType';
import {
    MstTransportTypeFromJSON,
    MstTransportTypeFromJSONTyped,
    MstTransportTypeToJSON,
    MstTransportTypeToJSONTyped,
} from './MstTransportType';

/**
 * 
 * @export
 * @interface TransportType
 */
export interface TransportType {
    /**
     * 
     * @type {number}
     * @memberof TransportType
     */
    datacount: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransportType
     */
    maxcount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof TransportType
     */
    lastUpdateDatetime: Date | null;
    /**
     * 
     * @type {Array<MstTransportType>}
     * @memberof TransportType
     */
    list: Array<MstTransportType>;
}

/**
 * Check if a given object implements the TransportType interface.
 */
export function instanceOfTransportType(value: object): value is TransportType {
    if (!('datacount' in value) || value['datacount'] === undefined) return false;
    if (!('maxcount' in value) || value['maxcount'] === undefined) return false;
    if (!('lastUpdateDatetime' in value) || value['lastUpdateDatetime'] === undefined) return false;
    if (!('list' in value) || value['list'] === undefined) return false;
    return true;
}

export function TransportTypeFromJSON(json: any): TransportType {
    return TransportTypeFromJSONTyped(json, false);
}

export function TransportTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportType {
    if (json == null) {
        return json;
    }
    return {
        
        'datacount': json['datacount'],
        'maxcount': json['maxcount'],
        'lastUpdateDatetime': (json['last_update_datetime'] == null ? null : new Date(json['last_update_datetime'])),
        'list': ((json['list'] as Array<any>).map(MstTransportTypeFromJSON)),
    };
}

export function TransportTypeToJSON(json: any): TransportType {
    return TransportTypeToJSONTyped(json, false);
}

export function TransportTypeToJSONTyped(value?: TransportType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datacount': value['datacount'],
        'maxcount': value['maxcount'],
        'last_update_datetime': value['lastUpdateDatetime'] == null ? value['lastUpdateDatetime'] : value['lastUpdateDatetime'].toISOString(),
        'list': ((value['list'] as Array<any>).map(MstTransportTypeToJSON)),
    };
}

